/* eslint-disable no-shadow */
import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import HelpBallon from '../../../../../../components/Intelligence/component/HelpBalloon/HelpBalloon';
import { getBotCustomReports } from '../../../../../../store/actions/reports';

import check from '../../../../../../assets/images/check.svg';

import './styles.scss';

const BotCustomReportList = (props) => {
  const { filter, match, user, botCustomReports } = props;
  const { botid: botId } = match.params;

  /**
   * Called for fetch new data for this component
   */
  useEffect(() => {
    if (user) {
      props.getBotCustomReports(botId, user.dashboard_token);
    }
  }, [user, filter]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (botId && user && user.dashboard_token) {
        const { getBotCustomReports } = props;
        getBotCustomReports(botId, user.dashboard_token);
      }
    }, 20000);
    return () => clearInterval(interval);
  }, []);

  const reportStatus = (report) => {
    switch (report.status) {
      case 'ok':
        return (
          <a
            href={report.url}
            className="btn btn-outline-primary"
            target="_blank"
            rel="noopener noreferrer"
            download
          >
            Download
          </a>
        );
      case 'pending':
        return <div className="semaforo pendente" />;
      case 'error':
        return <div className="semaforo erro" />;
      default:
        return null;
    }
  };

  return (
    <div className="container-list-report">
      <div className="list-title">
        <img src={check} alt="" />
        <p>Relatórios Produzidos</p>
      </div>

      <div className="list-report">
        <p>
          {botCustomReports.length === 0
            ? 'Você ainda não possui nenhum relatório criado.'
            : 'Os relatórios ficam somente 30 dias disponíveis para baixar.'}
        </p>
        <div className="list-scroll">
          <table className="table table-borderless">
            <tbody>
              {botCustomReports.map((report) => (
                <tr key={report._id}>
                  <td>
                    <HelpBallon
                      id="help-ballon-check-agente"
                      message={`
                      ${report?.name} - ${report?.fileFormat};
                      _id = ${report._id}; data: ${report.createdAt}
                    `}
                    />
                    <span>{`
                    ${report?.name || 'Não Definido'} -
                    ${report?.fileFormat || 'Não Definido'}
                  `}</span>
                  </td>
                  <td>{reportStatus(report)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.users.signedUser,
  bot: state.bots.bot,
  botCustomReports: state.reports.botCustomReports,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getBotCustomReports }, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(BotCustomReportList))
);
